import { Galerie } from '@components/galerie/models';
import { galerieTextMock, imageMock, videoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const galerie2iv2itMock: Block<Galerie> = {
  type: 'galerie',
  data: {
    layout: '2iv2it',
    title: {
      text: `Les couleurs [[tendances]]`,
      as: 'h2',
    },
    description: `Parce qu'un projet c'est un travail d'équipe, nous vous conseillons et vous accompagnons à chaque étape de la réalisation de votre cuisine.`,
    hideLastItem: false,
    items: [
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
      {
        video: videoMock(),
      },
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
      {
        text: galerieTextMock,
      },
    ],
  },
};
